module.exports = "/images/image6.jpg?98e75f1d5622e2a0c1480ce59e631706";